const FRAME_URL = /https?:\/\/[^\s)]+/g;

const hostsInTrace = (trace?: string[]) =>
  (trace || []).flatMap(frame =>
    (frame.match(FRAME_URL) || []).flatMap(raw => {
      try {
        return [new URL(raw.replace(/:\d+:\d+$/, '')).host];
      } catch (_error) {
        return [];
      }
    })
  );

export const isParentPageConsoleTrace = (
  trace: string[] | undefined,
  parentHost: string
) => {
  const hosts = hostsInTrace(trace);
  if (!parentHost || hosts.length === 0) return true;

  return hosts.some(host => host === parentHost);
};

type RecordedConsoleLog = {
  level?: string;
  payload?: string[];
  trace?: string[];
};

export const consoleLogFrom = (event: {
  data?: RecordedConsoleLog & {
    plugin?: string;
    payload?: RecordedConsoleLog | string[];
    source?: number;
  };
}): RecordedConsoleLog | null => {
  if (event.data?.plugin === 'rrweb/console@1') {
    const payload = event.data.payload;
    return payload && !Array.isArray(payload) ? payload : null;
  }
  if (event.data?.source === 11) return event.data;

  return null;
};
